<template>
  <section v-if="error">
  <br/>
  <p class="error">{{ error }}</p>
  </section>
  <section class="page-container grid-container" v-if="!error && loaded">
    <div class="grid-container wizard">
      
        <section>    
        <div class="grid-x grid-margin-x">
            <div class="cell small-12">
                <a @click="router.back()">← Back</a>
            </div>
        </div>
        </section>

        <section v-if="fileTask.taskStatus === 'SuccessfullyCompleted'">
            <div class="grid-x grid-margin-x">
                <div class="cell small-12">
                    <h1>{{ fileTask.taskName }} Collection</h1>
                    <p>Your file - {{ fileTask.displayName }} - has been uploaded successfully.</p>
                    <p>If you have any other files to upload, please go ahead and complete those tasks. We'll then be able to start migrating your payroll.</p>
                </div>
            </div>
            <br/>
            <button v-if="userType == 'Administrator'"  class="btn btn-primary" @click="downloadFile">Download file</button><button class="btn btn-secondary" @click="router.back()">Return</button>
        </section>
        <section v-else>
            <div class="grid-x grid-margin-x">
                <div class="cell small-12">
                    <h1>{{ fileTask.taskName }} Collection</h1>
                    <p>Please upload your file for the <span style="text-transform: lowercase">{{ fileTask.taskName }}</span> collection.</p>
                    <p>If you'd like to download our own template file, then <a :href="getTemplateFilePath()">click here</a>. You can then complete it offline, and come back here later once you've completed it.</p>
                    <FileUploader :multiple="false" :folderName="'filecollection'" ref="fileUploadReference" />
                    <br/>
                    <button class="btn btn-primary" @click="submitFiles">Submit</button>
                </div>
            </div>

        </section>
    </div>
  </section>
</template>

<script setup>
import { onMounted, ref, computed } from 'vue'
import { useRouter } from 'vue-router'
import { getFileCollectionTask, putFileCollectionTask } from '@/services/implementationmanagement.api';
import FileUploader from '@/components/controls/FileUploader.vue'
import { toRaw } from 'vue';
import { useIdentityStore } from '@/stores/identity';

import { postFile, getFile } from '@/services/blobstoragecommunicator.func.js';


const identity = useIdentityStore();
const userType = computed(() => identity.type)

const router  = useRouter()
const loaded = ref(false);
const taskId = router.currentRoute.value.params.taskId;
const error = ref(null);
const fileTask = ref(null);
const fileUploadReference = ref(null)


const errorString = 'An error has occurred. Please contact your Qtac account manager.';

const fileName = computed(() => {
    if (!fileTask.value?.blobStorageUrl) return null;

    const file = new URL(fileTask.value.blobStorageUrl)
        .pathname
        .split('/')
        .pop();

    return file ? decodeURIComponent(file) : null;
});

onMounted(async () => {

    try {
        var taskResponse = await getFileCollectionTask(taskId);

        if(taskResponse.status !== 200 || taskResponse.data === null || taskResponse.data === undefined) {
            error.value = errorString;
            return null;
        }

        fileTask.value = taskResponse.data;


    } catch (err) {
        error.value = errorString;
        console.error(err);
    }



loaded.value = true;
})

const downloadFile = async () => {
    const name = fileName.value;
    if (!name) return;

    try {
        const response = await getFile('',name);

        const blob = response.data;
        const downloadUrl = URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = downloadUrl;
        link.download = decodeURIComponent(name);
        document.body.appendChild(link);

        link.click();
        link.remove();

        URL.revokeObjectURL(downloadUrl);
    } catch (error) {
        console.error('Failed to download file:', error);
    }
};


const submitFiles = async () => {
  let uploadedFiles = [];

  if (fileUploadReference.value) {
    const files = await fileUploadReference.value.uploadToBlobStorage();

    uploadedFiles = files.map(file => ({
      fileName: file.data.filename,
      blobUri: file.data.url,
      taskId: taskId
    }));
  }

  if (uploadedFiles.length > 0) {
    const firstFile = uploadedFiles[0];

    // Update the reactive object
    fileTask.value.fileName = firstFile.fileName;
    fileTask.value.blobStorageUrl = firstFile.blobUri;
    fileTask.value.displayName = fileTask.value.qtacEntityName + '.csv';
    fileTask.value.taskStatus = 'SuccessfullyCompleted';

    // Send only the raw object, not the ref
    const payload = toRaw(fileTask.value);


    var updateResponse = await putFileCollectionTask(taskId, payload);


    if (updateResponse.status === 200) {

        
    } else {
      console.error('Error updating file task:', updateResponse);
    }
  }
};


// Function that selects file path to public folder / import-templates/
    const getTemplateFilePath = () => {
        const entityName = fileTask.value.qtacEntityName;
        switch (entityName) {
            case 'Employee':
                return '/import-templates/employee.csv';
            case 'YearToDateMain':
                return '/import-templates/year-to-date-main.csv';
            case 'YearToDateNI':
                return '/import-templates/year-to-date-ni.csv';
            case 'YearToDateStatutory':
                return '/import-templates/year-to-date-statutory.csv';
            case 'YearToDateAEPension':
                return '/import-templates/year-to-date-ae-pension.csv';
            default:
                return null;
        }
    };

</script>

